/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */

class ArtifactoryModelSaver {
    constructor(controller, modelObjects, excludePaths) {
        this.$modelSaver = window.$modelSaver;
        this.modelObjects = modelObjects;
        modelObjects.forEach((objName, index) => {
            this.$modelSaver.registerModel({
                id: objName,
                getModelRef: () => controller[objName],
                excludePaths: excludePaths[index]
            })
        })
    }

    save() {
        this.modelObjects.forEach((objName)=>{
            this.$modelSaver.saveModel(objName);
        });
    }

    isModelSaved() {
        let isSaved = true;
        for (let objectNameI in this.modelObjects) {
            let objectName = this.modelObjects[objectNameI];
            if (this.$modelSaver.isModelChanged(objectName)) {
                isSaved = false;
                break;
            }
        }
        return isSaved;
    }

    ask(reset = false) {
        return this.$modelSaver.ask(reset);
    }
}

export function ArtifactoryModelSaverFactory() {
    return {
        createInstance: (controller,modelObjects,excludePaths = []) => {
            return new ArtifactoryModelSaver(controller, modelObjects, excludePaths);
        }
    }
}



// WEBPACK FOOTER //
// ./services/artifactory_model_saver.js